goog.provide("shadow.js.shim.module$slate");
goog.provide("module$shadow_js_shim_module$slate");
shadow.js.shim.module$slate = shadow.js.nativeProvides["slate"] = shadow$bridge("slate");
module$shadow_js_shim_module$slate.default = shadow.js.shim.module$slate;
